import { useState } from 'react';
import clsx from 'clsx';

import NavMenuItem from './NavMenuItem/NavMenuItem';

import css from './NavMenu.module.scss';

const BASE_MENU = [
  {
    paragraph: 'Platforms',
    children: [
      { to: '/mt5', label: 'MT5' },
      { to: '/account', label: 'Account Types' },
    ],
    img: '/assets/content/menu_img_2.png',
  },
  {
    paragraph: 'Resources',
    children: [
      { to: '/tutorial', label: 'Tutorials' },
      { to: '/news', label: 'News' },
      { to: '/glossary', label: 'Glossary' },
      { to: '/faq', label: 'FAQ' },
    ],
    img: '/assets/content/menu_img_3.png',
  },
  {
    paragraph: 'Company',
    children: [
      { to: '/about', label: 'About RIIB' },
      { to: '/legal-pack', label: 'Legal Pack' },
      { to: '/contact', label: 'Contact Us' },
    ],
    img: '/assets/content/menu_img_4.png',
  },
  {
    paragraph: 'For Partners',
    to: '/partners',
  },
];

const NavMenu = ({ isMobile, setMobileMenuOpen, navigationData }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleItemClick = () => {
    if (isMobile) {
      setMobileMenuOpen(false);
      setOpenIndex(null); // згортає всі пункти
    }
  };

  return (
    <nav
      className={clsx(
        css.navmenu,
        !isMobile && css.header,
        isMobile && css.mobmenu
      )}
    >
      <ul className={css.navmenu__list}>
        {navigationData.map((item, index) => (
          <NavMenuItem
            key={index}
            index={index}
            itemData={item}
            isMobile={isMobile}
            openIndex={openIndex}
            setOpenIndex={setOpenIndex}
            onItemClick={handleItemClick}
          />
        ))}
      </ul>
    </nav>
  );
};

export default NavMenu;
